<template>
    <v-container>
        <v-card>
            <v-card-text v-if="dependants?.length > 0">
                <v-tabs v-model="tabDependants"
                        color="deep-purple-accent-4"
                        align-tabs="start">
                    <v-tab v-for="dependant of dependants" :value="dependant.id">
                        {{ $filters.capitalize(dependant.name) }}
                    </v-tab>
                </v-tabs>
                <v-window v-model="tabDependants">
                    <v-window-item v-for="dependant of dependants" :value="dependant.id">
                        <v-row>
                            <v-col>
                                <v-card-text>
                                    <FormularioCadastro
                                                        :group_id="dependant.group_id"
                                                        :user="user"
                                                        :me="{ legal_person: dependant }"
                                                        :new="false"
                                                        :admin="groupAdmin"
                                                        :person-type="dependant.type"
                                                        @updated="updatedLegalPerson" />
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-card-text>
            <v-card-text v-else class="text-center">
                SEM DEPENDENTES
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import FormularioCadastro from "../components/FormularioCadastro.vue";
import api from '@/services'
export default {
    components: {
        FormularioCadastro
    },
    props: {
        user: Object
    },
    data() {
        return {
            requestingApi: false,
            tabDependants: '',
            dependants: []
        };
    },
    created() {
        const vm = this;

        vm.listDependants();
    },
    computed: {
        groupAdmin() {
            const vm = this;

            return vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
        }
    },
    methods: {
        listDependants() {
            const vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.legalPerson.listDependants().then((result) => {
                        vm.dependants = result || [];
                    }).catch((err) => {
                        if (err.message) {
                            vm.$notify({
                                type: "warn",
                                text: err.message,
                            });
                        }
                    }).finally(() => {
                        vm.requestingApi = false;
                    });
                });
            }
        },
        updatedLegalPerson(legalPerson) {
        }
    }
};
</script>